<template lang="pug">
el-row.labels-filters
  el-col(:sm="8", :offset="8")
    el-card(header="Етикети")
      .cf(slot="header")
        span Етикети
        small.fr(v-if="subscribersCount !== null && subscriptionsCount != null") {{ subscribersCount }} Абоната / {{ subscriptionsCount }} Абонамента


      el-select(v-model="filters.year")
        el-option(:label="currentYear", :value="currentYear")
        el-option(:label="currentYear+1", :value="currentYear+1")

      el-select(v-model="filters.delivery", placeholder="Всички доставки", clearable)
        el-option(v-for="(delivery, value) in consts.subjectDelivery", :label="delivery", :value="parseInt(value)", :key="value")

      el-select(v-model="filters.subscriptionVariant", placeholder="Всички варианти", clearable)
        el-option(v-for="(variant, value) in consts.subscriptionVariant", :label="variant.title", :value="parseInt(value)", :key="value")

      el-select(v-model="filters.paymentStatus", placeholder="Платени и Неплатени", clearable)
        el-option(v-for="(status, value) in consts.paymentStatus", :label="status.title", :value="parseInt(value)", :key="value")

      el-select(v-model="filters.city", placeholder="Всички градове", clearable)
        el-option(label="София", value="capital")
        el-option(label="Страната", value="rest")

      el-select(v-model="filters.format")
        el-option(value="pdf", label="PDF/Етикети")
        el-option(value="csv", label="CSV")
        el-option(value="json", label="JSON")
        //- el-option(value="html", label="HTML")

      el-button(type="primary", @click="getLabels") Генерирай

</template>

<script>
export default {
  name: 'Labels',
  data () {
    return {
      subscribersCount: null,
      subscriptionsCount: null,
      filters: {
        format: 'pdf',
        year: new Date().getFullYear(),
        delivery: '',
        subscriptionVariant: '',
        paymentStatus: 2,
        city: ''
      }
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
    filtersQuery () {
      return Object.keys(this.filters).map(key => `${key}=${this.filters[key]}`).join('&')
    }
  },
  methods: {
    getLabels () {
      // window.open('${this.$baseURL}labels?year='+this.year+'&format=pdf')
      window.open(`${this.$baseURL}labels?${this.filtersQuery}&token=${this.$auth.token()}`)
    }
  },
  created () {
    this.$watch('filters', (newFilters, oldFilters) => {
      const params = {...this.filters, count: true}
      this.$http.get('/labels', {params}).then(response => {
        this.subscribersCount = response.data.subscribersCount
        this.subscriptionsCount = response.data.subscriptionsCount
      }).catch(err => {
        console.error(error)
        this.$notify.error({title: 'Error', message: 'Error loading count filter. Check console.'});
      })
    }, {
      immediate: true,
      deep: true
    })
  }
}
</script>

<style lang="stylus">
.labels-filters
  .el-select
    margin-bottom 10px
</style>